import LeviMarketingAPI from './LeviMarketingAPI';
const leviMarketingAPIURL = process.env.GATSBY_LEVI_MARKETING_API_URL || '';

class LeviMarketingClient extends LeviMarketingAPI {
  protected static override _API_URL = leviMarketingAPIURL;
  protected static override _API_KEY = process.env.GATSBY_MODER_FRENDS_APIKEY || '';
}

export default LeviMarketingClient;
